(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelsro-store"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pelsro-product')) {
  customElements.define('pelsro-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-gallery-image]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const main = this.querySelector('.pr-main-image');
        if (!main) return;
        event.preventDefault();
        const image = main.querySelector('img');
        image.removeAttribute('srcset');
        image.src = link.dataset.galleryImage;
        main.href = link.href;
        this.querySelectorAll('.pr-thumb').forEach((thumb) => {
          if (thumb.dataset.galleryImage === link.dataset.galleryImage) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="id"]')) return;
        this.querySelector('[data-color-name]').textContent = event.target.dataset.color;
        this.querySelector('[data-product-price]').textContent = event.target.dataset.price;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
